import { render, staticRenderFns } from "./QuotaAggregate.vue?vue&type=template&id=d87f598e"
import script from "./QuotaAggregate.vue?vue&type=script&lang=js"
export * from "./QuotaAggregate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports